import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { OTransportCompanies } from "shared/gol-api/types/flightSearch";

interface Props {
  airlineCode: string;
}

const AirlineTitle: React.FC<Props> = ({ airlineCode }) => {
  const oTransportCompanies: OTransportCompanies = useSelector(
    (state: AppState) => state.search.oTransportCompanies
  );
  const title = oTransportCompanies[airlineCode]
    ? oTransportCompanies[airlineCode].Name.$t
    : null;
  return <span>{title}</span>;
};

export default AirlineTitle;
